import React, { useEffect, useState } from "react";
import { IconButton } from "@alm/flow-ds/components";
import { Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { getNotifUnread, getUsername } from "data/app/appSelectors";
import useUnreadCounts from "hooks/useUnreadCount";
import { useTranslation } from "react-i18next";
import MenuOpen from "components/Menu/MenuOpen";
import ProfileMenu from "./ProfileMenu";

interface Props {
	setIsNotificationsTrayOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function TaskBar({ setIsNotificationsTrayOpen }: Props) {
	const { t } = useTranslation();
	const history = useHistory();

	const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

	const reduxUnreadCount = useSelector(getNotifUnread);
	const handleUnreadCount = useUnreadCounts();

	useEffect(() => {
		handleUnreadCount();
	}, [handleUnreadCount]);

	// TODO: Change this in the future to pull from notifications properly if a new one comes in.
	useEffect(() => {
		// Listen to router and pull for unread notifs count when location changes
		const unlisten = history.listen(location => {
			if (location.pathname !== "/") {
				handleUnreadCount();
			}
		});
		return function cleanup() {
			unlisten();
		};
	}, [handleUnreadCount, history]);

	const username: string = useSelector(getUsername);

	return (
		<>
			<header aria-label="taskbar">
				<ul className="taskbar__menu">
					<li className="taskbar__item taskbar__item--home">
						<Link
							to="/"
							className="taskbar__item-link taskbar__item-link--home"
							title={t("main.taskBar.logoAltText")}>
							<img
								src="/images/logo.svg"
								className="brand-logo"
								aria-hidden="false"
								alt={t("main.taskBar.logoAltText")}
							/>
						</Link>
					</li>
					<li className="taskbar__item taskbar__item--title">
						Axiell Flow
					</li>
					<li className="taskbar__item taskbar__item--notifications">
						<IconButton
							icon="bell"
							className="btn-alt"
							iconWeight="l"
							label={
								reduxUnreadCount !== 0
									? t(
											"main.notifications.notificationsIcon",
											{
												count: reduxUnreadCount,
											}
									  )
									: t(
											"main.notifications.noNotificationsIcon"
									  )
							}
							onClick={() => {
								setIsNotificationsTrayOpen(true);
							}}>
							{reduxUnreadCount !== 0 ? (
								<span className="badge badge-danger">
									{reduxUnreadCount}
								</span>
							) : null}
						</IconButton>
					</li>
					{/* TODO: desktop grid icon to be used in the future? */}
					{/* <li className="taskbar__item taskbar__item--desktop-menu">
						<IconButton
							icon="th"
							iconWeight="s"
							className="btn-alt"
							label={t("main.taskBar.userMenu")}
						/>
					</li> */}
					{/* <li className="taskbar__item taskbar__item--mobile-menu">
						<IconButton
							icon=""
							iconWeight="l"
							className="btn-alt"
							label={t("main.taskBar.userMenu")}
							onClick={() => setIsMenuOpen(true)}
						/>
					</li> */}
					<li className="taskbar__item taskbar__item-profile--container">
						<ProfileMenu username={username || ""} />
					</li>
					<li className="taskbar__item taskbar__item--mobile-menu">
						<IconButton
							icon="bars"
							iconWeight="l"
							className="btn-alt"
							label={t("main.taskBar.userMenu")}
							onClick={() => setIsMenuOpen(true)}
						/>
					</li>
				</ul>
			</header>
			{/* Sidebar in mobile view */}
			{isMenuOpen && (
				<nav className="mobile-menu menu open">
					<MenuOpen closeMenu={() => setIsMenuOpen(false)} />
				</nav>
			)}
		</>
	);
}

export default TaskBar;
